module.exports = __webpack_public_path__ + "img/workshops.f27ac825.svg";